import LOGO from "../images/LaChona.png";

export const Team__LaChona = {
  name: "La Chona",
  logoImage: LOGO,
  teamImage: null,
  teamLogoColor: "#1E3A8A",
  teamJerseyColor: "#111111",

  // Stats
  gamesWon: 0,
  gamesLost: 3,
  gamesTied: 0,
  gamesTiedWon: 0,

  ownGoalsInFavor: 29 + 50 + 34,
  goalsScoredAgainst: 69 + 58 + 44,
  defaultGoals: 0,

  isChampion: false,
  isEliminated: false,

  players: [],
};
